import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bootstrap-size-indicator',
  templateUrl: './bootstrap-size-indicator.component.html',
  styleUrls: ['./bootstrap-size-indicator.component.scss']
})
export class BootstrapSizeIndicatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
